import React, { useState, useEffect, useRef } from "react";
import enableTableSearch from "../utility/table";
import ExportCSV from "./ExportCSV";
import API_BASE_URL from "../config";

function RangeTable({ reload }) {
  const [ranges, setRanges] = useState([]);
  const inputRef = useRef();
  const tableRef = useRef();

  useEffect(() => {
    fetch(API_BASE_URL + "/api/range")
      .then((res) => res.json())
      .then((data) => setRanges(data.ranges))
      .catch((err) => console.error("Error fetching range:", err));
  }, [reload]);

  useEffect(() => {
    const cleanup = enableTableSearch({
      inputRef,
      tableRef,
      columnIndex: 1,
      noDataText: "No range found",
    });

    return cleanup;
  }, []);

  return (
    <div id="table-container">
      <div id="header">
        <p>Range List</p>
      </div>
      <hr />
      <div id="table-actions">
        <ExportCSV
          entries={ranges.map((item, index) => [item.name, item.address])}
          header={["NAME", "ADDRESS"]}
        />
        <div className="search-box">
          <label>Search:</label>
          <input type="text" id="search" name="search" ref={inputRef} />
        </div>
      </div>
      <table>
        <thead>
          <tr>
            <th>SL NO.</th>
            <th>NAME</th>
            <th>ADDRESS</th>
          </tr>
        </thead>
        <tbody id="table-body" ref={tableRef}>
          {ranges.map((item, index) => (
            <tr key={item.id}>
              <td>{item.id}</td>
              <td>{item.name}</td>
              <td>{item.address}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RangeTable;
